export const USER = {
  displayName: "binx",
  jobTitle: "Software Developer & UI/UX Designer",
  company: "binx",
  location: "Earth",
  bio: "A really cool person.",
  website: "https://binx.com",
  urls: [
    "https://binx.io.vn",
    "https://binx.id.vn",
  ],
  contacts: {
    email: "binx@gmail.com",
    tel: "+84999999999",
    social: {
      github: "https://github.com/binx",
      twitter: "https://x.com/binx",
      youtube: "https://youtube.com/@binx",
      linkedin: "https://linkedin.com/in/binx",
    },
  },
  avatar: "https://assets.binx.com/images/binx-avatar-ghibli.jpeg",
  ogImage: "https://assets.binx.com/images/screenshot-og-image-dark.png",
  keywords:
    "binx, binx, iambx, quaric, zadark",
};
